import React from 'react';
import { useRecoilCallback, useRecoilValue } from 'recoil';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { accountIdSelectedAtom, accountsAtom, languageAtom, tokenAtom, urlLogoutAtom } from 'atoms';
import i18n from 'locales/i18n';
import Layout from 'components/Layout';

function ExternalAccessPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get(`token`);
  const lang = searchParams.get(`lang`);
  const urlLogout = searchParams.get(`urlLogout`);
  const navigate = useNavigate();
  const tokenValue = useRecoilValue(tokenAtom);

  const setToken = useRecoilCallback(
    ({ set }) =>
      (newToken: string | null, newLang: string | null, newUrlLogout: string | null) => {
        setTimeout(() => set(tokenAtom, newToken), 0);
        setTimeout(() => set(urlLogoutAtom, newUrlLogout), 0);

        let language = 'pt';
        if (Number(newLang) === 2) {
          language = 'es';
        } else if (Number(newLang) === 3) {
          language = 'en';
        }

        setTimeout(() => set(languageAtom, language), 0);
        i18n.changeLanguage(language);
      },
    [],
  );

  React.useEffect(
    function setNewData() {
      setToken(token, lang, urlLogout);
    },
    [setToken, token, lang, urlLogout],
  );

  const resetAccounts = useRecoilCallback(
    ({ reset }) =>
      () => {
        reset(accountsAtom);
        reset(accountIdSelectedAtom);
        setTimeout(() => {
          navigate('/');
        }, 0);
      },
    [],
  );

  React.useEffect(
    function resetAccountsAtom() {
      if (tokenValue === token) {
        resetAccounts();
      }
    },
    [tokenValue, token, resetAccounts],
  );

  return (
    <Layout.Container>
      <Layout.Content sx={{ alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Layout.Content>
    </Layout.Container>
  );
}

export default ExternalAccessPage;
